import React from 'react'

type Props = {
  categories: string[]
}

const GiftCardCategoryBadges = ({categories}: Props) => {
  if (!categories.length) return <>—</>
  return (
    <>
      {categories.map((category, index) => (
        <span key={`${category}-${index}`} className='badge badge-secondary me-2'>
          {category}
        </span>
      ))}
    </>
  )
}

export default GiftCardCategoryBadges
